<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span class="fa fa-file-text-o"></span>Create a claim</div>
    </div>

    <div class="content">
        <div>
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-2 label">Policy Number:</div>
                        <div class="col-md-4">
                            <div class="p-inputgroup">
                                <input type="text" pInputText placeholder="Policy Number" name="policyNumber"
                                       [(ngModel)]="policyNumber"/>
                            </div>
                        </div>
                        <div class="col-md-2 label">Claim Number:</div>
                        <div class="col-md-4">
                            <div class="p-inputgroup">
                                <input type="text" pInputText placeholder="Claim Number" name="claimNumber"
                                       [(ngModel)]="claimNumber"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-2"></div>
                <div class="col-md-2">
                    <button pButton type="button" class="p-button-raised full-width" label="New claim"
                            (click)="newClaim()"
                            name="newClaim"></button>
                </div>
                <!--<div class="col-md-2">
              <button pButton type="button" class="p-button-raised full-width" label="Add attachments"></button>
            </div>-->
                <div class="col-md-2">
                    <button pButton type="button" class="p-button-raised full-width" label="Save claim"
                            (click)="saveClaim()"
                            [disabled]="isSaving" name="saveClaim"></button>
                </div>

            </div>
            <div class="row" style="padding-top:5px">
                <div class="col-md-1 label">Document Link:</div>
                <div class="col-md-5">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Link to documents" name="documentLink"
                               [(ngModel)]="documentLink"/>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="content">
        <div>
            <div class="row">
                <div class="col-md-6">


                    <div class="row margin-top-8">
                        <h5 style="margin-left: 15px;">Insurer Details:</h5>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">Insurer:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <!--<input type="text" pInputText placeholder="Insurer" name="insurer" [(ngModel)]="insurer" />-->
                                <p-dropdown [options]="insurers" [(ngModel)]="selectedInsurer"></p-dropdown>
                            </div>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">Agent:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <input type="text" pInputText placeholder="Agent's name" name="agentName"
                                       [(ngModel)]="agentName"/>
                            </div>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">eMail:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <input type="email" pInputText placeholder="Agent's eMail" name="agenteMail"
                                       [(ngModel)]="agenteMail"/>
                            </div>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">Phone:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <input type="text" pInputText placeholder="Agent's phone number" name="agentPhone"
                                       [(ngModel)]="agentPhone"/>
                            </div>
                        </div>
                    </div>


                </div>

                <div class="col-md-6">

                    <div class="row margin-top-8">
                        <h5 style="margin-left: 15px;">Insured Details:</h5>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">Name:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <input type="text" pInputText placeholder="Insured's name" name="insuredName"
                                       [(ngModel)]="insuredName"/>
                            </div>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">eMail:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <input type="email" pInputText placeholder="Insured's eMail" name="insuredeMail"
                                       [(ngModel)]="insuredeMail"/>
                            </div>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">Phone:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <input type="text" pInputText placeholder="Insured's phone number" name="insuredPhone"
                                       [(ngModel)]="insuredPhone"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>


    </div>

    <div class="content">
        <div>

            <div class="row">
                <div class="col-md-6">


                    <div class="row margin-top-8">
                        <h5 style="margin-left: 15px;">Item Details:</h5>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">Bikes:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <p-chips [(ngModel)]="bikes" class="full-width"
                                         placeholder="Enter bike name and press enter. Multiple bikes can be added."
                                         [addOnBlur]="true"
                                         (onAdd)="addBike($event)" (onRemove)="removeBike($event)"></p-chips>
                                <!--<textarea pInputTextarea [rows]="5" placeholder="Bike details and components installed on the bike" name="bikeSetup" [(ngModel)]="itemDetails"></textarea>-->
                            </div>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">Bike Selection:</div>
                        <div class="col-md-8">
                            <div class="p-inputgroup">
                                <!--<p-dropdown [options]="bikeSelectList" [(ngModel)]="bikeSelected" placeholder="Select a bike to add components to"></p-dropdown>-->
                                <!--<textarea pInputTextarea [rows]="5" placeholder="Bike details and components installed on the bike" name="bikeSetup" [(ngModel)]="itemDetails"></textarea>-->

                                <div class="p-g" style="margin-bottom:10px">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="col-md-12" *ngFor="let col of bikeSelectList"
                                                 style="padding:5px;">
                                                <div>
                                                    <p-radioButton name="bikesGroup" value="{{col.label}}"
                                                                   label="{{col.label}}"
                                                                   [(ngModel)]="bikeSelected" inputId="opt1"
                                                                   (onClick)="showComponents()"></p-radioButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--<div *ngIf="bikeAdded && bikeSelected"> -->
                    <div>
                        <div class="row margin-top-8">
                            <div class="col-md-4 label">Components:</div>
                            <div class="col-md-8">
                                <div class="p-inputgroup">
                                    <p-chips [(ngModel)]="components" class="full-width"
                                             placeholder="Enter components for the above selected bike."
                                             [addOnBlur]="true"
                                             (onAdd)="addComponentToBike($event)"
                                             (onRemove)="removeComponentToBike($event)"></p-chips>
                                    <!--<textarea pInputTextarea [rows]="5" placeholder="Bike details and components installed on the bike" name="bikeSetup" [(ngModel)]="itemDetails"></textarea>-->
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-4 label">Sum insured:</div>
                            <div class="col-md-8">
                                <div class="p-inputgroup">
                                    <input type="number" (blur)="addSumInsuredToBike()" pInputText
                                           placeholder="Sum insured"
                                           name="sumInsured" [(ngModel)]="sumInsured"/>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-4 label">Excess:</div>
                            <div class="col-md-8">
                                <div class="p-inputgroup">
                                    <input type="number" (blur)="addExcessToBike()" pInputText placeholder="Excess"
                                           name="excess"
                                           [(ngModel)]="excess"/>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!--<div *ngIf="bikeAdded">-->
                    <div>
                        <div class="row margin-top-8">
                            <h5 style="margin-left: 15px;">Incident Details:</h5>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-4 label">Type of Incident:</div>
                            <div class="col-md-8">
                                <div class="p-inputgroup">
                                    <!--<input type="text" pInputText placeholder="Insurer" name="insurer" [(ngModel)]="insurer" />-->
                                    <p-dropdown [options]="incidentTypes"
                                                [(ngModel)]="selectedIncidentType"></p-dropdown>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-4 label">Incident Date:</div>
                            <div class="col-md-8">
                                <div class="p-inputgroup">
                                    <p-calendar [(ngModel)]="incidentDate" placeholder="Incident date"
                                                dateFormat="yy-mm-dd"></p-calendar>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-4 label">Incident Location:</div>
                            <div class="col-md-8">
                                <div class="p-inputgroup">
                                    <input type="text" pInputText [(ngModel)]="incidentLocation"
                                           placeholder="Address where incident occured" name="incidentLocation"/>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-4 label">Incident Description:</div>
                            <div class="col-md-8">
                                <div class="p-inputgroup">
                  <textarea pInputTextarea [rows]="5" placeholder="Description of the incident that led to the claim"
                            name="incidentDetails" [(ngModel)]="incidentDetails"></textarea>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <!--<div class="col-md-4">
                  <div class="row margin-top-8">
                    <h5 style="margin-left: 15px;">Images:</h5>
                  </div>

                  <div class="col-md-12">
                    <p-galleria [images]="images" panelWidth="500" panelHeight="313" showCaption="true"></p-galleria>
                  </div>


                </div>-->
                <div class="col-md-6">
                    <div class="row margin-top-8">
                        <h5 style="margin-left: 15px;">Attachments:</h5>
                    </div>
                    <!--todo: dcorbett multiple was wront here-->
                    <p-fileUpload [customUpload]="true" name="demo[]" (onUpload)="onUpload($event)"
                                  (uploadHandler)="onUpload($event)" (onRemove)="onRemove($event)"
                                  [multiple]="true" [maxFileSize]="1000000000" [auto]="true" [showUploadButton]="false"
                                  [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <!--<ul *ngIf="uploadedFiles.length">
                              <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                            </ul>-->
                        </ng-template>
                    </p-fileUpload>

                </div>
            </div>
        </div>


    </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
